import { motion } from "framer-motion";

export default function PageHero({ overline, title, accentWord, description, image, breadcrumb, rightImage, rightImageAlt = "", rightVideo, rightVideoPoster }) {
  return (
    <section className="relative pt-40 pb-20 overflow-hidden">
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/30" />
          <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-transparent to-white" />
        </div>
      )}
      <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${rightImage ? "grid lg:grid-cols-12 gap-10 items-center" : ""}`}>
        <div className={rightImage ? "lg:col-span-7" : ""}>
          {breadcrumb && (
            <div className="text-xs text-navy-500 mb-4 tracking-wide" data-testid="page-breadcrumb">
              {breadcrumb}
            </div>
          )}
          {overline && <span className="section-overline">{overline}</span>}
          <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="mt-3 font-heading text-5xl sm:text-6xl lg:text-7xl text-navy-900 leading-[1.05] tracking-tight max-w-4xl"
          >
            {title}
            {accentWord && (
              <>
                {" "}
                <em className="italic text-gold-600 font-medium">{accentWord}</em>
              </>
            )}
          </motion.h1>
          {description && (
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 max-w-2xl text-lg text-navy-700/80 leading-relaxed space-y-4"
            >
              {typeof description === "string" ? <p>{description}</p> : description}
            </motion.div>
          )}
        </div>
        {(rightImage || rightVideo) && (
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
            className="lg:col-span-5 hidden lg:block"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-navy-100/60">
              {rightVideo ? (
                <video
                  data-testid="page-hero-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  poster={rightVideoPoster}
                  className="h-[440px] w-full object-cover"
                >
                  <source src={rightVideo} type="video/mp4" />
                </video>
              ) : (
                <img src={rightImage} alt={rightImageAlt} className="h-[440px] w-full object-cover" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/30 via-transparent to-transparent" />
            </div>
            <div className="absolute -z-10 -top-10 -right-10 h-64 w-64 rounded-full bg-gold-500/15 blur-3xl" />
          </motion.div>
        )}
      </div>
    </section>
  );
}
